import { LocationCard } from '../LocationCard'
import type { Location } from '@/lib/types/map'

interface GoogleMapProps {
	locations: Location[]
}

export default function DealerCards({ locations }: GoogleMapProps) {
	return (
		<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 xl:gap-x-12 xl:gap-y-10">
			{locations.map((location) => (
				<LocationCard key={location.id} {...location} isDealerCard />
			))}
		</div>
	)
}
